/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

import { DocumentPlus, PersonBook } from '../../../components/buttons/IconButtons';

export const PROFILE_VIEW = {
    USER_DATA: 'USER_DATA',
    EXTRA_DATA: 'EXTRA_DATA',
    BADGES: 'BADGES',
};

export const PROFILE_TABS = [
    {
        id: 0,
        key: PROFILE_VIEW.USER_DATA,
        translation: 'user_data',
        icon: <DocumentPlus className='h-18px w-18px' />,
    },
    {
        id: 1,
        key: PROFILE_VIEW.EXTRA_DATA,
        translation: 'extra_data',
        icon: <PersonBook className='h-18px w-18px' />,
    },
    {
        id: 2,
        key: PROFILE_VIEW.BADGES,
        translation: 'badges',
        icon: <PersonBook className='h-18px w-18px' />,
    },
];

export const CREATE_CATEGORY_MODEL = {
    name: '',
    contractorId: null,
    type: null,

    isValid: function () {
        return this.name.trim() !== '';
    },
    toRegister: function (type, contractorId) {
        return {
            name: this.name,
            contractorId: contractorId,
            type: type,
        };
    },
};
